export { default } from "./Aside";



// WEBPACK FOOTER //
// ./src/pages/tutorial/aside/index.js